module.exports = __webpack_public_path__ + "img/bnr.96421a7.png";